<template>
  <div
    id="invoiceInfo"
    class="mainCard"
  >
    <Invoice
      v-loading="loading.information || globalLoading"
      :role-type="user.user.role_type"
      :edit-flag.sync="editFlag"
      :request-mode.sync="requestMode"
      :loading.sync="loading.information"
      :invoice.sync="information"
      :saved-flag.sync="savedFlag"
      :countries="countries"
      :responsive-row="responsiveRow"
      class="eachCard"
      @updatedFetch="updatedFetch"
    />
    <Beneficiary
      v-loading="loading.beneficiary || globalLoading"
      :role-type="user.user.role_type"
      :edit-flag.sync="editFlag"
      :request-mode.sync="requestMode"
      :loading.sync="loading.beneficiary"
      :invoice.sync="information"
      :saved-flag.sync="savedFlag"
      :countries="countries"
      :responsive-row="responsiveRow"
      class="eachCard"
      @updatedFetch="updatedFetch"
    />
    <Bank
      v-loading="loading.bank_detail || globalLoading"
      :role-type="user.user.role_type"
      :edit-flag.sync="editFlag"
      :request-mode.sync="requestMode"
      :loading.sync="loading.bank_detail"
      :invoice.sync="information"
      :saved-flag.sync="savedFlag"
      :countries="countries"
      :responsive-row="responsiveRow"
      class="eachCard"
      @updatedFetch="updatedFetch"
    />

    <div
      v-if="!isRootPlatform"
      class="importBtnWrap"
    >
      <el-button
        class="clearBtn"
        round
        :loading="importLoading"
        @click="importInvoice"
      >
        {{ $t('coach.invoice.importInfo') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import api from '@/api';
import Invoice from './widgets/invoice/Invoice.vue';
import Beneficiary from './widgets/invoice/Beneficiary.vue';
import Bank from './widgets/invoice/Bank.vue';

export default {
  components: {
    Invoice,
    Beneficiary,
    Bank,
  },

  data: () => ({
    // RequestMode ? post : patch
    requestMode: 'post',
    importLoading: false,

    // Loading globally or separately
    globalLoadingList: [],
    loading: {
      information: false,
      beneficiary: false,
      bank_detail: false,
    },

    // Allow only one section to edit
    editFlag: {
      invoice: false,
      beneficiary: false,
      bank_detail: false,
    },

    // Country data
    countries: [],

    // Follow backend's 'is_beneficiary_same' field, set by default
    savedFlag: false,

    // Invoice detail data
    information: {
      name: '',
      phone_number: '',
      invoice_number: '',
      address_line1: '',
      address_line2: '',
      postal_code: '',
      location_data: {
        country_id: null,
        country_name: '',
        region_id: null,
        region_name: '',
        city_id: null,
        city_name: '',
      },
      is_beneficiary_same: true,
      beneficiary: {
        name: '',
        address_line1: '',
        address_line2: '',
        postal_code: '',
        location_data: {
          country_id: null,
          country_name: '',
          region_id: null,
          region_name: '',
          city_id: null,
          city_name: '',
        },
      },
      bank_detail: {
        name: '',
        swift_code: '',
        account_number: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        postal_code: '',
        iban: '',
        location_data: {
          country_id: null,
          country_name: '',
          region_id: null,
          region_name: '',
          city_id: null,
          city_name: '',
        },
      },
    },
  }),

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    responsiveRow() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 24;
        col.two = 24;
      } else {
        col.one = 24;
        col.two = 12;
      }
      return col;
    },

    globalLoading() {
      let result = false;
      if (this.globalLoadingList) {
        result = !!this.globalLoadingList.length;
      }
      return result;
    },

    isRootPlatform() {
      let flag = false;
      if (process.env.VUE_APP_SERVICE === 'gcg_platform') { flag = true; }
      return flag;
    },
  },

  created() {
    this.getInvoiceDetail();
    this.getCountries();
  },

  methods: {
    async getInvoiceDetail() {
      try {
        this.globalLoadingList.push('run');
        let response = null;
        response = await api.getInvoiceDetail();

        if (response && response.data) {
          if (Object.entries(response.data).length > 0) {
            // If there is data, request mode turn to patch
            this.requestMode = 'patch';

            this.savedFlag = response.data.is_beneficiary_same;
            // locationDataSafe() {
            //   if (this.invoice && this.invoice.location_data) {
            //     const fields = [
            //       'country_id',
            //       'country_name',
            //       'region_id',
            //       'region_name',
            //       'city_id',
            //       'city_name',
            //     ];
            //     const initData = {
            //       country_id: null,
            //       country_name: '',
            //       region_id: null,
            //       region_name: '',
            //       city_id: null,
            //       city_name: '',
            //     };
            //     const data = Object.keys(this.invoice.location_data);
            //     fields.forEach((key) => {
            //       if (!data.includes(key)) { this.invoice.location_data[key] = initData[key]; }
            //     });
            //   }
            // },
            Object.keys(response.data).forEach((key) => {
              if (key !== 'bank_detail') {
                this.information[key] = response.data[key];
              } else if (key === 'bank_detail' && response.data[key] && Object.entries(response.data[key]).length) {
                this.information[key] = response.data[key];
              }
            });
          }
        }
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.globalLoadingList.pop();
      }
    },

    async getCountries() {
      try {
        this.globalLoadingList.push('run');

        const response = await api.getCountriesList();

        if (response.data) {
          this.countries = response.data.sort((a, b) => {
            const one = (a.name).toLowerCase();
            const two = (b.name).toLowerCase();
            let result = 0;

            if (one > two) {
              result = 1;
            }
            if (one < two) {
              result = -1;
            }
            if (one === two) {
              result = 0;
            }

            return result;
          });
        }
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.globalLoadingList.pop();
      }
    },

    updatedFetch(data) {
      this.globalLoadingList.push('run');
      Object.keys(data).forEach((key) => {
        if (key !== 'bank_detail') {
          this.information[key] = data[key];
        } else if (key === 'bank_detail' && data[key]) {
          this.information[key] = data[key];
        }
      });
      this.savedFlag = data.is_beneficiary_same;
      this.globalLoadingList.pop();
    },

    async importInvoice() {
      this.$confirm(`${this.$t('common.warning')} - ${this.$t('coach.invoice.importInfoDesc')}`, `${this.$t('coach.invoice.importInfo')}`, {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        roundButton: true,
      }).then(async () => {
        try {
          this.importLoading = true;
          await api.importInvoiceDetail();
          this.getInvoiceDetail();
          this.$message.success(this.$t('coach.invoice.importSuccess'));
        } catch (err) {
          console.log(err);
          this.$message.error(err.msg);
        } finally {
          this.importLoading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  #invoiceInfo {
    .eachCard {
      margin-bottom: 15px;
    }

    .importBtnWrap {
      width: 100%;
      text-align: center;
      padding-top: 15px;

      .clearBtn {
        padding: 13px 15px;
        background-color: transparent;
        word-break: break-word;
        white-space: normal;
        color: white;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
    }
  }
</style>

<style lang="scss">
  #invoiceInfo {
    .el-row {
      display: flex;
      flex-wrap: wrap;
    }
  }
  // Required Red Asterisk symbol hide
  .el-form-item__label {
    &::after {
      display: none;
    }
  }
</style>
